import type { SiteRegion } from '../enums';

export const AccountInfoService = Symbol.for('AccountInfoService');

export interface AccountInfoService {
    getModelData: () => {
        site_region: SiteRegion;
    };
}
